module.exports = __webpack_public_path__ + "img/england-logo-icon.10f3c760.png";